module.exports = __webpack_public_path__ + "img/case2.e6fb0475.png";